export const NO_BRAND = 'Sin marca';

export function brandsOf(products: { brand?: string | null }[]): string[] {
  return Array.from(new Set(products.map(p => p.brand).filter(Boolean) as string[]))
    .sort((a, b) => a.localeCompare(b, 'es'));
}

export const brandLabel = (brand?: string | null) => brand?.trim() || NO_BRAND;
